import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Components/Functions/date.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { useSelector } from "react-redux";
const tableHead = [
  "Sr.",
  "Project",
  "Date of Creation",
  "Site Selection",
  "Status",
  "Actions",
];
const ComplatedProjectTable = ({ PT = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const user = useSelector((store) => store.login.user.Role);
  const isSalesCoordinator =
    user === "salesCoordinator" || user === "superAdmin";

  // const getTaskListDetails = (task = []) => {
  //     const totalTasks = task.length;

  //     if (totalTasks === 0) {
  //         return {
  //             statusText: `0/0`,
  //             isCompleted: false,
  //         };
  //     }

  //     const completedTasks = task?.filter((t) => t.isUpdated || t.isNotApplicable);

  //     const allTasksCompleted = completedTasks.length === totalTasks;

  //     // ✅ Get second-last task (index - 2)
  //     const secondLastTask = task[totalTasks - 1];
  //     const secondLastTaskCompleted = secondLastTask?.isUpdated || secondLastTask?.isNotApplicable;

  //     // ✅ Final condition
  //     const isCompleted = allTasksCompleted || secondLastTaskCompleted;

  //     return {
  //         statusText: `${completedTasks.length}/${totalTasks}`,
  //         isCompleted,
  //     };
  // };

  // const visibleProjects = PT.filter((item) => {
  //     const { isCompleted } = getTaskListDetails(item?.taskList || []);
  //     return isSalesCoordinator ? isCompleted : true;
  // });

  const goToView = (id) => {
    navigate(`/complete-projects/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {PT.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            // const { statusText, isCompleted } = getTaskListDetails(item?.taskList);

            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.projectClientName || "N/A"}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>{item?.siteClientName || "N/A"}</td>
                <td>
                  <span className="badge bg-success text-white">Completed</span>
                </td>
                <td>
                  <CustomViewButton onClick={() => goToView(item.projectId)} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ComplatedProjectTable;
